"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
var _AccountContext = _interopRequireDefault(require("../../context/AccountContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AccountData = props => {
  const {
    authorID
  } = props;
  const [accountData, setAccountData] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    const fetchAccountData = async () => {
      const {
        REACT_APP_PATH
      } = process.env;
      const accountDataUrl = "".concat(REACT_APP_PATH, "/api/account/data/").concat(authorID);
      const loginToken = localStorage.getItem("logintoken");
      const headers = {};
      if (loginToken) {
        headers.Authorization = "Bearer ".concat(loginToken);
      }
      const response = await _axios.default.get(accountDataUrl, {
        headers
      });
      setAccountData(response.data);
    };
    if (!authorID) return null;
    fetchAccountData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorID]);
  return /*#__PURE__*/_react.default.createElement(_AccountContext.default.Provider, {
    value: [accountData, setAccountData]
  }, props.children);
};
var _default = exports.default = AccountData;